import { MapPin, Clock } from "lucide-react";
import { ZONA_SUL, ZONA_NORTE, CENTRO } from "@/data/products";
import { waLink } from "@/lib/whatsapp";
import { trackWhatsAppClick } from "@/lib/analytics";

const Grupo = ({ titulo, bairros, prefixo }) => (
  <div>
    <p className="text-[10px] tracking-[0.25em] uppercase text-[#BFA573] mb-3">{titulo}</p>
    <ul className="grid grid-cols-2 gap-2">
      {bairros.map((b) => (
        <li key={b}>
          <a
            href={waLink(`Olá! Preciso de uma coroa de flores para entregar em ${b}. Podem me ajudar?`)}
            target="_blank" rel="noreferrer"
            onClick={() => trackWhatsAppClick(`bairro_${prefixo}`, { bairro: b })}
            data-testid={`bairro-${b.toLowerCase().replace(/\s/g,'-')}`}
            className="group flex items-center gap-2 bg-white border border-[#E5E3DB] rounded-lg px-3 py-2 hover:border-[#2D4A3E] hover:-translate-y-0.5 transition-all"
          >
            <MapPin className="h-3.5 w-3.5 text-[#BFA573] flex-shrink-0 group-hover:text-[#2D4A3E] transition-colors" strokeWidth={1.5} />
            <span className="text-xs text-[#1C1C1C] font-medium">{b}</span>
          </a>
        </li>
      ))}
    </ul>
  </div>
);

// Seção principal de SEO — foco Zona Sul, Zona Norte e Centro do RJ
export const ZonaSul = () => {
  return (
    <section id="zona-sul" className="py-20 md:py-28 bg-[#F4F2EC]">
      <div className="container-wide">
        <div className="max-w-3xl">
          <span className="overline">Nossa cobertura</span>
          <h2 className="text-4xl md:text-5xl font-semibold text-[#2D4A3E] leading-tight mt-3 tracking-tight">
            Coroa de Flores na Zona Sul, Zona Norte e Centro do Rio
          </h2>
          <p className="mt-5 text-[#5C5C5C] leading-relaxed text-lg">
            Entregamos coroas de flores em <strong className="text-[#2D4A3E] font-medium">toda a Zona Sul, Zona Norte e Centro</strong> do Rio de Janeiro —
            e no <strong className="text-[#2D4A3E] font-medium">Cemitério São João Batista</strong>, em Botafogo. Atendimento 24 horas por dia.
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-8 grid sm:grid-cols-3 gap-8">
            <Grupo titulo="Zona Sul"   bairros={ZONA_SUL}   prefixo="sul" />
            <Grupo titulo="Zona Norte" bairros={ZONA_NORTE} prefixo="norte" />
            <Grupo titulo="Centro"     bairros={CENTRO}     prefixo="centro" />
          </div>

          {/* Card destaque — Cemitério São João Batista */}
          <div className="lg:col-span-4">
            <div className="bg-[#2D4A3E] text-white rounded-2xl p-7 relative overflow-hidden">
              <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-[#BFA573]/20 blur-2xl" />
              <div className="relative">
                <span className="text-[10px] tracking-[0.25em] uppercase text-[#BFA573]">Principal cemitério</span>
                <h3 className="text-2xl font-semibold mt-2 leading-tight">Cemitério São João Batista</h3>
                <p className="text-white/80 text-sm mt-2">R. Real Grandeza · Botafogo</p>

                <div className="mt-6 space-y-3 text-sm">
                  <div className="flex items-start gap-2.5">
                    <Clock className="h-4 w-4 text-[#BFA573] flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                    <span className="text-white/90">Entrega <strong className="font-medium">grátis</strong> (mesma rua da nossa central)</span>
                  </div>
                  <div className="flex items-start gap-2.5">
                    <MapPin className="h-4 w-4 text-[#BFA573] flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                    <span className="text-white/90">Também: Caju, Memorial do Carmo, Catumbi e Penitência</span>
                  </div>
                </div>

                <a
                  href={waLink("Olá! Preciso de uma coroa de flores para o Cemitério São João Batista em Botafogo.")}
                  target="_blank" rel="noreferrer"
                  onClick={() => trackWhatsAppClick("sjb_card")}
                  data-testid="zona-sul-sjb-whatsapp"
                  className="mt-7 inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1FB855] text-white font-medium px-5 py-2.5 rounded-full text-sm transition-all duration-300 hover:-translate-y-0.5 w-full"
                >
                  Pedir para o São João Batista
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
